import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiPublicationApprovalGetVehiclesForCompanyParams,
  BackendErrorEntity,
  ConfirmApprovalBodyDto,
  ConfirmApprovalResponseDto,
  GetVehiclesForCompanyResponseDto,
  PublicationApprovalEntity,
  SendApprovalBodyDto,
  SendApprovalResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiPublicationApprovalConfirm = (
    confirmApprovalBodyDto: MaybeRef<ConfirmApprovalBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      confirmApprovalBodyDto = unref(confirmApprovalBodyDto);
      
      return fetchApiInstance<ConfirmApprovalResponseDto>(
      {url: `/publicationApprovals/confirmApproval`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmApprovalBodyDto
    },
      options);
    }
  


export const getApiPublicationApprovalConfirmMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalConfirm>>, TError,{data: BodyType<ConfirmApprovalBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalConfirm>>, TError,{data: BodyType<ConfirmApprovalBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPublicationApprovalConfirm>>, {data: BodyType<ConfirmApprovalBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPublicationApprovalConfirm(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPublicationApprovalConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof apiPublicationApprovalConfirm>>>
    export type ApiPublicationApprovalConfirmMutationBody = BodyType<ConfirmApprovalBodyDto>
    export type ApiPublicationApprovalConfirmMutationError = ErrorType<BackendErrorEntity>

    export const useApiPublicationApprovalConfirm = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalConfirm>>, TError,{data: BodyType<ConfirmApprovalBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPublicationApprovalConfirm>>,
        TError,
        {data: BodyType<ConfirmApprovalBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPublicationApprovalConfirmMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiPublicationApprovalDelete = (
    id: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
      
      return fetchApiInstance<void>(
      {url: `/publicationApprovals/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiPublicationApprovalDeleteMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalDelete>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPublicationApprovalDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  apiPublicationApprovalDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPublicationApprovalDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiPublicationApprovalDelete>>>
    
    export type ApiPublicationApprovalDeleteMutationError = ErrorType<BackendErrorEntity>

    export const useApiPublicationApprovalDelete = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPublicationApprovalDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getApiPublicationApprovalDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiPublicationApprovalGetByBusAssetId = (
    busAssetId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      busAssetId = unref(busAssetId);
      
      return fetchApiInstance<PublicationApprovalEntity>(
      {url: `/publicationApprovals/byBusAsset/${busAssetId}`, method: 'GET'
    },
      options);
    }
  

export const getApiPublicationApprovalGetByBusAssetIdQueryKey = (busAssetId: MaybeRef<string | undefined | null>,) => {
    return ['publicationApprovals','byBusAsset',busAssetId] as const;
    }

    
export const getApiPublicationApprovalGetByBusAssetIdQueryOptions = <TData = Awaited<ReturnType<typeof apiPublicationApprovalGetByBusAssetId>>, TError = ErrorType<BackendErrorEntity>>(busAssetId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiPublicationApprovalGetByBusAssetId>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiPublicationApprovalGetByBusAssetIdQueryKey(busAssetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPublicationApprovalGetByBusAssetId>>> = () => apiPublicationApprovalGetByBusAssetId(busAssetId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(busAssetId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiPublicationApprovalGetByBusAssetId>>, TError, TData> 
}

export type ApiPublicationApprovalGetByBusAssetIdQueryResult = NonNullable<Awaited<ReturnType<typeof apiPublicationApprovalGetByBusAssetId>>>
export type ApiPublicationApprovalGetByBusAssetIdQueryError = ErrorType<BackendErrorEntity>



export function useApiPublicationApprovalGetByBusAssetId<TData = Awaited<ReturnType<typeof apiPublicationApprovalGetByBusAssetId>>, TError = ErrorType<BackendErrorEntity>>(
 busAssetId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiPublicationApprovalGetByBusAssetId>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiPublicationApprovalGetByBusAssetIdQueryOptions(busAssetId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiPublicationApprovalGetVehiclesForCompany = (
    companyId: MaybeRef<string | undefined | null>,
    params?: MaybeRef<ApiPublicationApprovalGetVehiclesForCompanyParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      companyId = unref(companyId);
params = unref(params);
      
      return fetchApiInstance<GetVehiclesForCompanyResponseDto>(
      {url: `/companyPublicationApprovals/${companyId}`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiPublicationApprovalGetVehiclesForCompanyQueryKey = (companyId: MaybeRef<string | undefined | null>,
    params?: MaybeRef<ApiPublicationApprovalGetVehiclesForCompanyParams>,) => {
    return ['companyPublicationApprovals',companyId, ...(params ? [params]: [])] as const;
    }

    
export const getApiPublicationApprovalGetVehiclesForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof apiPublicationApprovalGetVehiclesForCompany>>, TError = ErrorType<BackendErrorEntity>>(companyId: MaybeRef<string | undefined | null>,
    params?: MaybeRef<ApiPublicationApprovalGetVehiclesForCompanyParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiPublicationApprovalGetVehiclesForCompany>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiPublicationApprovalGetVehiclesForCompanyQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPublicationApprovalGetVehiclesForCompany>>> = () => apiPublicationApprovalGetVehiclesForCompany(companyId,params, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(companyId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiPublicationApprovalGetVehiclesForCompany>>, TError, TData> 
}

export type ApiPublicationApprovalGetVehiclesForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof apiPublicationApprovalGetVehiclesForCompany>>>
export type ApiPublicationApprovalGetVehiclesForCompanyQueryError = ErrorType<BackendErrorEntity>



export function useApiPublicationApprovalGetVehiclesForCompany<TData = Awaited<ReturnType<typeof apiPublicationApprovalGetVehiclesForCompany>>, TError = ErrorType<BackendErrorEntity>>(
 companyId: MaybeRef<string | undefined | null>,
    params?: MaybeRef<ApiPublicationApprovalGetVehiclesForCompanyParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiPublicationApprovalGetVehiclesForCompany>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiPublicationApprovalGetVehiclesForCompanyQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiPublicationApprovalSend = (
    sendApprovalBodyDto: MaybeRef<SendApprovalBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      sendApprovalBodyDto = unref(sendApprovalBodyDto);
      
      return fetchApiInstance<SendApprovalResponseDto>(
      {url: `/publicationApprovals/sendApproval`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendApprovalBodyDto
    },
      options);
    }
  


export const getApiPublicationApprovalSendMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalSend>>, TError,{data: BodyType<SendApprovalBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalSend>>, TError,{data: BodyType<SendApprovalBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPublicationApprovalSend>>, {data: BodyType<SendApprovalBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiPublicationApprovalSend(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPublicationApprovalSendMutationResult = NonNullable<Awaited<ReturnType<typeof apiPublicationApprovalSend>>>
    export type ApiPublicationApprovalSendMutationBody = BodyType<SendApprovalBodyDto>
    export type ApiPublicationApprovalSendMutationError = ErrorType<BackendErrorEntity>

    export const useApiPublicationApprovalSend = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPublicationApprovalSend>>, TError,{data: BodyType<SendApprovalBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPublicationApprovalSend>>,
        TError,
        {data: BodyType<SendApprovalBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPublicationApprovalSendMutationOptions(options);

      return useMutation(mutationOptions);
    }
    